/* eslint-disable no-console */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-lonely-if */
import React from "react";
import { Checkbox } from "antd";
import ModuleHeader from "./ModuleHeader";
import TrikeIcon from "../../../Common/Svgs/TrikeIcon";
import { trikePermissions } from "./data";
import PermissionTitle from "./PermissionTitle";
import { PERMISSIONS } from "../../Login/constants";
import {
  trikeAddEditDelete,
  trikeAddService,
  trikeChecklistAddEditDelete,
  trikeGeofenceAddEditDelete,
  trikeViewQR,
} from "./permissionFunctions";

const CONDITIONS = {
  VIEW_AND_EDIT: [PERMISSIONS.TRIKE_VIEW, PERMISSIONS.TRIKE_NO_ACCESS],
  // VIEW_ONLY: ["trike_view_and_edit", "trike_no_access"],
  // NO_ACCESS: ["trike_view_and_edit", PERMISSIONS.TRIKE_VIEW],
  REMOVE_ALL: [
    PERMISSIONS.TRIKE_ADD,
    PERMISSIONS.TRIKE_EDIT,
    PERMISSIONS.TRIKE_DELETE,
    PERMISSIONS.TRIKE_DISPATCH_AND_MOVE,
    PERMISSIONS.TRACKER_SWITCH,
    PERMISSIONS.TRIKE_MOBILISE,
    PERMISSIONS.TRIKE_CHECKLIST_ADD,
    PERMISSIONS.TRIKE_CHECKLIST_EDIT,
    PERMISSIONS.TRIKE_CHECKLIST_DELETE,
    PERMISSIONS.TRIKE_GEOFENCE_ADD,
    PERMISSIONS.TRIKE_GEOFENCE_EDIT,
    PERMISSIONS.TRIKE_GEOFENCE_DELETE,
    PERMISSIONS.TRIKE_ISSUE_ADD,
    PERMISSIONS.TRIKE_ISSUE_VIEW,
    PERMISSIONS.TRIKE_ADD_TO_SERVICE,
    PERMISSIONS.TRIKE_VIEW_QR,
    PERMISSIONS.TRIKE_NO_SERVICE,
    PERMISSIONS.TRIKE_NO_QR,
    PERMISSIONS.TRIKE_VIEW,
    PERMISSIONS.TRIKE_VIEW_AND_EDIT,
    PERMISSIONS.TRIKE_NO_ACCESS,
  ],
};

const TrikePermissions = ({ permissions, setPermissions, visible = true }) => {
  // check if the permissions needs to be disabled
  const disabled = CONDITIONS.VIEW_AND_EDIT.some((d) =>
    permissions.includes(d),
  );

  const handleModulePermission = (permissionId) => {
    let local = [];

    if (permissionId === PERMISSIONS.TRIKE_VIEW_AND_EDIT) {
      local = permissions.filter(
        (item) => !CONDITIONS.VIEW_AND_EDIT.includes(item),
      );
    }

    // removing all the trike permissions
    if (permissionId === PERMISSIONS.TRIKE_VIEW) {
      local = permissions.filter(
        (item) => !CONDITIONS.REMOVE_ALL.includes(item),
      );
    }

    // removing all the trike permissions
    if (permissionId === PERMISSIONS.TRIKE_NO_ACCESS) {
      local = permissions.filter(
        (item) => !CONDITIONS.REMOVE_ALL.includes(item),
      );
    }

    setPermissions([...local, permissionId]);
  };

  const handleIndividualPermission = (permissionId) => {
    let local = [];

    if (permissions.includes(permissionId)) {
      local = permissions.filter((item) => item !== permissionId);
      setPermissions(local);
    } else {
      if (permissionId === PERMISSIONS.TRIKE_ADD) {
        // handling multiple insertions for trike add, edit, delete
        trikeAddEditDelete({ setPermissions });
      } else if (permissionId === PERMISSIONS.TRIKE_CHECKLIST_ADD) {
        // handling multiple insertions for trike checklist add, edit, delete
        trikeChecklistAddEditDelete({ setPermissions });
      } else if (permissionId === PERMISSIONS.TRIKE_GEOFENCE_ADD) {
        // handling multiple insertions for trike geofence add, edit, delete
        trikeGeofenceAddEditDelete({ setPermissions });
      } else if (
        permissionId === PERMISSIONS.TRIKE_ADD_TO_SERVICE ||
        permissionId === PERMISSIONS.TRIKE_NO_SERVICE
      ) {
        // handling either add or don't add to service
        trikeAddService({ current: permissionId, permissions, setPermissions });
      } else if (
        permissionId === PERMISSIONS.TRIKE_VIEW_QR ||
        permissionId === PERMISSIONS.TRIKE_NO_QR
      ) {
        // handling either view or don't view QR
        trikeViewQR({ current: permissionId, permissions, setPermissions });
      } else {
        setPermissions((prev) => [...prev, permissionId]);
      }
    }
  };

  // should not show the UI if the visible is false
  if (!visible) return <div />;

  return (
    <div>
      <ModuleHeader
        module="Trikes"
        icon={<TrikeIcon size={16} className="text-primary" />}
      />
      {/* main module permission */}
      <div className="w-full h-[60px]">
        <div
          className="flex items-center w-full h-full border-b"
          style={{
            background: "#FAF2D8",
            borderColor: "#FAD152",
          }}
        >
          <div
            className="w-[40%] border-r py-3 px-6"
            style={{
              borderColor: "#FAD152",
            }}
          >
            <PermissionTitle
              title={trikePermissions[0].title}
              description={trikePermissions[0].description}
            />
          </div>

          <div className="w-[60%] h-full flex items-center">
            {trikePermissions[0].options.map((option) => {
              // rendering empty div for layout consistency
              if (!option) {
                return (
                  <div
                    className="w-[25%] border-r px-6 h-full flex items-center gap-x-2"
                    style={{
                      borderColor: "#FAD152",
                    }}
                  />
                );
              }

              const selected = permissions.includes(option.permissionId);

              return (
                <div
                  key={option.text}
                  className="w-[25%] border-r px-6 h-full flex items-center gap-x-2"
                  style={{
                    borderColor: "#FAD152",
                  }}
                >
                  <Checkbox
                    checked={selected}
                    onClick={() => handleModulePermission(option.permissionId)}
                  />
                  <p
                    className={`font-poppins text-xs ${
                      selected ? "font-medium" : "font-normal"
                    }`}
                  >
                    {option.text}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* individual functionality permission */}
      <div className="w-full">
        {trikePermissions.slice(1).map((item) => {
          return (
            <div
              key={item.id}
              className="flex items-center w-full h-[60px] border-b"
              style={{
                borderColor: "#DFDFDF",
              }}
            >
              <div
                className="w-[40%] h-full border-r py-3 px-6"
                style={{
                  borderColor: "#DFDFDF",
                }}
              >
                <PermissionTitle
                  title={item.title}
                  description={item.description}
                />
              </div>

              <div className="w-[60%] h-full flex items-center">
                {item.options.map((option, idx) => {
                  // rendering empty div for layout consistency
                  if (!option) {
                    return (
                      <div
                        key={idx}
                        className="w-[25%] h-full border-r px-6 flex items-center gap-x-2"
                        style={{
                          borderColor: "#DFDFDF",
                        }}
                      />
                    );
                  }

                  const selected = permissions.includes(option.permissionId);

                  // if the permission is view only, remove pointer events and add an opacity
                  return (
                    <div
                      key={option.text}
                      className="w-[25%] h-full border-r px-6 flex items-center gap-x-2"
                      style={{
                        borderColor: "#DFDFDF",
                        opacity: disabled && 0.5,
                        pointerEvents: disabled && "none",
                      }}
                    >
                      {/* if the permissions should be disabled then it should not
                      show any tick mark else show the selected tick mark */}
                      <Checkbox
                        checked={disabled ? false : selected}
                        onClick={() =>
                          handleIndividualPermission(option.permissionId)
                        }
                      />
                      <p
                        className={`font-poppins text-xs
                        ${selected ? "font-medium" : "font-normal"}
                        `}
                      >
                        {option.text}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TrikePermissions;
